import { Dispatch } from '../../types'

export enum ActionType {
  ScreenSize = 'Monitoring/ScreenSize'
}

export type ScreenSizeAction = {
  type: ActionType.ScreenSize,
  payload: { width: number, height: number }
}

export type RootAction =
  | ScreenSizeAction

const screenSizeAction = (width: number, height: number): RootAction => ({
  type: ActionType.ScreenSize,
  payload: { width, height }
})

export const saveScreenSize = (width: number, height: number) => (dispatch: Dispatch) => {
  dispatch(screenSizeAction(width, height))
}
